class BoostPfs extends HTMLElement {
  constructor() {
    super();
    this.loadMoreBtnClass = '.boost-pfs-filter-btn-load-previous-page';
    this.listeners();
  }

  listeners() {
    const observer = new MutationObserver(() => {
      const loadMoreBtn = this.querySelector(this.loadMoreBtnClass);
      if (loadMoreBtn) {
        loadMoreBtn.click();
        const allPagesLoaded = !!loadMoreBtn.closest('.boost-pfs-filter-btn-load-previous-page-wrapper[style="display: none;"]');
        if (allPagesLoaded) observer.disconnect();
      }
    });
    observer.observe(this, { childList: true, subtree: true });
  }
}

customElements.define("boost-pfs", BoostPfs);